module.exports = __webpack_public_path__ + "media/images/btn_create_organization-09e749c8f9824f3f204d2b728b9fed72.gif";